const VAULT = {
  race: {
    raceName: ''
  },
  gender: {
    genderName: ''
  },
  className: 'Vault',
  emblemPath: 'https://www.bungie.net/common/destiny_content/icons/971ab9229b8164aff89c7801f332b54c.jpg',
  emblemBackgroundPath: 'https://www.bungie.net/common/destiny_content/icons/61d32219f2ce198d6295c65554a64808.jpg',
  characterId: 'VAULT',
  bucketHash: 138197802,
  isVault: true
}

const INVENTORY = {
  race: {
    raceName: ''
  },
  gender: {
    genderName: ''
  },
  className: 'Characters',
  emblemPath: 'https://www.bungie.net/common/destiny_content/icons/971ab9229b8164aff89c7801f332b54c.jpg',
  emblemBackgroundPath: 'https://www.bungie.net/common/destiny_content/icons/61d32219f2ce198d6295c65554a64808.jpg',
  characterId: 'INVENTORY',
  bucketHash: 138197802,
  isVault: true
}

export const getCharacter = (state) => (characterId) => {
  if (state.characters) {
    if (characterId === 'VAULT') {
      return VAULT
    } else if (characterId === 'INVENTORY') {
      return INVENTORY
    }
    return state.characters.find(character => character.characterId === characterId)
  }
}

export const getCurrentCharacter = (state, getters) => getters.getCharacter(state.selectedCharacter)

export const itemsByBucketForCurrentCharacter = (state, getters) => ({bucket}) => {
  if (state.selectedCharacter === 'VAULT') {
    // vault is one large bucket
    return state.items.filter(item => item.character.characterId === 'VAULT')
  }
  return getters.itemsByBucket({bucket, characterId: state.selectedCharacter})
}

export const itemsByBucket = (state, getters) => ({bucket, characterId}) => {
  return state.items.filter(item => item.bucket === bucket && item.character.characterId === characterId)
}

export const allItemsCategories = (state) => {
  return [...new Set(state.items.map(item => item.bucket))]
}



// WEBPACK FOOTER //
// ./src/store/destiny/profile/getters.js